module.exports = __webpack_public_path__ + "static/fonts/AmwayIcons.e68987a.eot";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/relayevent/font/AmwayIcons.eot?5v2gxx
// module id = F43K
// module chunks = 0